import EditorModal from 'components/shared/DocumentEditor/components/EditorModal';

import useDocumentPreview from '../hooks/useDocumentPreview';

const type = 'pdf';
const kind = 'labsoft_order_result';

const EditResultModal = ({
  activeView,
  setActiveView,
  editModal,
  historyMode,
  setIsLoading,
  setEditModal,
  setHistoryMode,
  isLoading
}) => {
  const { result, documentSrc, canvasStates, scale, loadDocument, setScale, setCanvasStates } =
    useDocumentPreview({
      activeView,
      setActiveView
    });

  const id = result?.id;
  const title = result?.report_title;

  return (
    <EditorModal
      {...{
        src: documentSrc,
        id,
        type,
        kind,
        loadDocument,
        title,
        editModal,
        setScale,
        historyMode,
        setIsLoading,
        canvasStates,
        scale,
        setEditModal,
        setHistoryMode,
        setCanvasStates,
        isLoading,
        isEditable: true
      }}
    />
  );
};

export default EditResultModal;
